import { useQuery } from '@apollo/client';
import { GET_COMPANY_COUNT_BY_LOCATION } from '@frontend/data-access';
import { Card, Spin } from 'antd';
import dayjs from 'dayjs';
import dynamic from 'next/dynamic';
import useTranslation from 'next-translate/useTranslation';
import { Suspense, useMemo } from 'react';

const WorldMapDynamic = dynamic(() => import('../DashboardGraphs/WorldMap'), {
  ssr: false,
});

function PopularCountryStats({ className }: { className?: string }) {
  const { t } = useTranslation('admin');

  const { data, loading } = useQuery<{
    companyCountByLocation: { location?: string; all: number }[];
  }>(GET_COMPANY_COUNT_BY_LOCATION, {
    variables: {
      startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
    },
  });

  const stats = useMemo(() => {
    return (
      data?.companyCountByLocation
        ?.filter((item) => item.location)
        .map((item) => ({
          country: item.location,
          count: item.all,
        }))
        .sort((a, b) => b.count - a.count) || []
    );
  }, [data]);

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
      className={`${className}`}
    >
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-900 font-medium">
            {t('companies_by_country')}
          </span>
        </div>
        <div style={{ height: 400 }}>
          {loading ? (
            <Spin />
          ) : (
            <Suspense fallback={<div>Loading...</div>}>
              <WorldMapDynamic loading={loading} stats={stats} />
            </Suspense>
          )}
        </div>
        <div>
          {stats.map((item) => (
            <div
              key={item.country}
              className="flex justify-between items-center gap-2"
            >
              <div className="text-sm text-gray-900 font-normal">
                {item.country}
              </div>
              <div className="text-sm text-gray-900 font-normal">
                {item.count}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}

export default PopularCountryStats;
